import React, { Component } from 'react';
import glamorous from 'glamorous';

const Wrapper = glamorous.div({
  display: 'flex',
  flexDirection: 'row'
});

const UnderlineInput = glamorous.div({
  borderBottom: '1px dashed #979797',
  cursor: 'pointer'
});

const CalendarIcon = glamorous.span({
  marginRight: 10
});

const icon = {
  calendar: () => (
    <svg width="18px" height="20px" viewBox="0 0 18 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Search---Results---Trips" transform="translate(-88.000000, -474.000000)" fill="#674DAA" fillRule="nonzero">
          <g id="Body" transform="translate(88.000000, 189.000000)">
            <g id="Filters">
              <g id="Distance" transform="translate(0.000000, 219.000000)">
                <g id="Group-4" transform="translate(0.000000, 66.000000)">
                  <path d="M6,9 L4,9 L4,11 L6,11 L6,9 Z M10,9 L8,9 L8,11 L10,11 L10,9 Z M14,9 L12,9 L12,11 L14,11 L14,9 Z M16,2 L15,2 L15,0 L13,0 L13,2 L5,2 L5,0 L3,0 L3,2 L2,2 C0.89,2 0.01,2.9 0.01,4 L0,18 C0,19.1 0.89,20 2,20 L16,20 C17.1,20 18,19.1 18,18 L18,4 C18,2.9 17.1,2 16,2 Z M16,18 L2,18 L2,7 L16,7 L16,18 Z" id="Shape"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
};

class CustomDateInput extends Component {
  render() {
    const {
      value,
      onClick,
      defaultText,
      style,
    } = this.props;

    return (
      <Wrapper style={style ? style : {}} >
        <CalendarIcon>{icon.calendar()}</CalendarIcon>
        <UnderlineInput
          onClick={onClick}
        >
          {value || defaultText}
        </UnderlineInput>
      </Wrapper>
    )
  }
}

export default CustomDateInput;



// WEBPACK FOOTER //
// ./src/components/pages/Search/CustomDateInput.jsx